module.exports = __webpack_public_path__ + "img/icon-list-blue.51203b1c.svg";